import { queryOptions } from '@tanstack/react-query'

import { w } from '@/lib/api'
import { API_ENDPOINTS } from '@/lib/constants/api'

import type { ResGetCaseProcessingTimeTrendQuery, ResUscisFormCategoriesQuery } from './types'

export const getCaseProcessingTimeTrendQueryKey = (filter: { category?: string; office?: string }) => [
  API_ENDPOINTS.case.public.trend['processing-time'].index,
  filter.category,
  filter.office,
]
export const getCaseProcessingTimeTrendQuery = (filter: { category?: string; office?: string; date: string }) => {
  const enabled = !!filter.category && !!filter.office

  return queryOptions({
    enabled,
    queryKey: getCaseProcessingTimeTrendQueryKey(filter),
    queryFn: () =>
      w
        .url(API_ENDPOINTS.case.public.trend['processing-time'].index)
        .query(filter)
        .get()
        .json<ResGetCaseProcessingTimeTrendQuery>(),
    retry: false,
    refetchOnWindowFocus: false,
  })
}

export const uscisFormCategoriesQuery = (caseType?: string) =>
  queryOptions<ResUscisFormCategoriesQuery>({
    queryKey: [API_ENDPOINTS.case.public.trend['processing-time']['optional-list'].index, caseType],
    queryFn: () =>
      w
        .url(API_ENDPOINTS.case.public.trend['processing-time']['optional-list'].index)
        .query({
          caseType,
        })
        .get()
        .json(),
    enabled: !!caseType,
  })
